/**
 * @generated SignedSource<<0efaa6d666a34a7744a7070260369a05>>
 * @relayHash 3dd161fdef7ceeacf68875edd7f57fa5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3dd161fdef7ceeacf68875edd7f57fa5

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DestroyAnomalyInput = {
  anomalyId: string;
  clientMutationId?: string | null;
};
export type examsDestroyAnomalyMutation$variables = {
  input: DestroyAnomalyInput;
};
export type examsDestroyAnomalyMutation$data = {
  readonly destroyAnomaly: {
    readonly deletedId: string;
  } | null;
};
export type examsDestroyAnomalyMutation = {
  response: examsDestroyAnomalyMutation$data;
  variables: examsDestroyAnomalyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DestroyAnomalyPayload",
    "kind": "LinkedField",
    "name": "destroyAnomaly",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "examsDestroyAnomalyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "examsDestroyAnomalyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3dd161fdef7ceeacf68875edd7f57fa5",
    "metadata": {},
    "name": "examsDestroyAnomalyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "958d591f0af24e435ee8a70a4dd4dc81";

export default node;
